export const contentWrapper = 'h-screen';
export const bannerContent = 'px-4';
export const wrapper = 'flex flex-col justify-center';
export const calendarTopWrapper = 'white';
export const calendarWrapper = '';
export const dialogContent = 'h-full overflow-y-hidden';
